export default __webpack_public_path__ + "static/media/notebooks.ce983213.png";